import { render, staticRenderFns } from "./_base-tab-panel.vue?vue&type=template&id=027576e5&scoped=true"
import script from "./_base-tab-panel.vue?vue&type=script&setup=true&lang=js"
export * from "./_base-tab-panel.vue?vue&type=script&setup=true&lang=js"
import style0 from "./_base-tab-panel.vue?vue&type=style&index=0&id=027576e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027576e5",
  null
  
)

export default component.exports